import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Period_Company_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_COMPANY_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB Company Id', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    COMPANY_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Company ID', columnResourceName: 'colUIId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    COMPANY_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Company Name',
            columnResourceName: 'colCompanyName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    ENTERPRISE_SET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Enterprise Set ID',
            columnResourceName: 'colEnterpriseSetID',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'WB MDSET ID', columnResourceName: 'colMDId', alignment: HorizAlignment.Left},
        domainOptions: {}
    },
    MDSET_NAME: {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Master Data Set', columnResourceName: 'colMDSetName', alignment: HorizAlignment.Left }, domainOptions: { maxLength: 256 }},
};



const PeriodCompanySearchProvider: ISearchProvider = {

    keyFields: {
        id: 'WB_COMPANY_ID',
        id_ui: 'COMPANY_ID',
        name: 'COMPANY_NAME'
    },

    searchProviderFields: vUI_Period_Company_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Period_Company_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};


const PeriodCompanySearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "PeriodCompanySearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'COMPANY_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'COMPANY_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'COMPANY_ID', 'COMPANY_NAME', 'MDSET_NAME', 'ENTERPRISE_SET_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PeriodCompanySearchProvider,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};


const PeriodCompanySearch: ISearch = {
    searchName: "Find Company",
    renderOptions: {ui5ResourceId: "PeriodCompanySearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [PeriodCompanySearchProfileByName]
};

export {PeriodCompanySearch}